function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useRef, useEffect } from 'react';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useTranslate, T } from 'shared/helper/translate';
import Files, { endpoints } from 'shared/helper/file';
import { FILE_STATUS } from 'shared/helper/file/constants';
import { Controls, useFormHelpers } from 'shared/helper/form';
import FileRubriq from 'shared/helper/file/components/FileRubriq';
import { syncUser } from 'rubriq/actions';
import { createPlagiarism } from 'researcher/plagiarism/actions';
import { initMixpanel, trackEvent } from 'rubriq/helpers/mixpanel';
import RubriqUploadButton from '../RubriqUploadButton';
import UploadImage from '../../images/upload.svg';
import RubriqPlagiarismStatus from './RubriqPlagiarismStatus';
var fileType = 'ithenticate';
var Form = Controls.Form;
var defaultValues = {
  plagiarismFiles: []
};
var PlagiarismCheckDocumentModal = function PlagiarismCheckDocumentModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    _ref$initialFiles = _ref.initialFiles,
    initialFiles = _ref$initialFiles === void 0 ? null : _ref$initialFiles;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    submitting = _useState2[0],
    setSubmitting = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    dragActive = _useState4[0],
    setDragActive = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    currentPageIndex = _useState6[0],
    setCurrentPageIndex = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showError = _useState8[0],
    setShowError = _useState8[1];
  var filePickerRef = useRef(null);
  var methods = useForm({
    defaultValues: defaultValues,
    shouldFocusError: false
  });
  var _methods$watch = methods.watch(['plagiarismFiles']),
    _methods$watch2 = _slicedToArray(_methods$watch, 1),
    plagiarismFiles = _methods$watch2[0];
  var hasFile = plagiarismFiles && plagiarismFiles.length > 0;
  var _useFormHelpers = useFormHelpers(),
    preprocessData = _useFormHelpers.preprocessData;
  var trackedUploadsRef = useRef(new Set());
  var dispatch = useDispatch();
  var wordCountAttempts = 0;
  useEffect(function () {
    if (open && initialFiles && initialFiles.length > 0) {
      methods.setValue('plagiarismFiles', initialFiles);
    }
  }, [open, initialFiles, methods]);
  var onCheckDocument = function onCheckDocument() {
    if (filePickerRef.current) {
      filePickerRef.current();
    }
  };
  useEffect(function () {
    if (!plagiarismFiles || plagiarismFiles.length === 0) return;
    var file = plagiarismFiles[0];

    // Only track after successful upload
    if (file.status !== FILE_STATUS.STATUS_UPLOAD_SUCCESS) return;
    var fileKey = file.identity;
    if (!fileKey) return;

    // Prevent duplicate tracking
    if (trackedUploadsRef.current.has(fileKey)) {
      return;
    }
    trackedUploadsRef.current.add(fileKey);
    var fileName = file.name || null;
    var fileType = fileName ? fileName.split('.').pop() : null;
    trackEvent('Plagiarism Document Uploaded', {
      file_name: fileName,
      file_type: fileType,
      uploaded_at: new Date().toISOString()
    });
  }, [plagiarismFiles]);
  var screens = [{
    title: /*#__PURE__*/React.createElement(T, {
      source: "upload-document"
    }),
    content: /*#__PURE__*/React.createElement(React.Fragment, null, !hasFile && /*#__PURE__*/React.createElement("div", {
      className: "p-3 mb-3 rounded popup-doc-pannel"
    }, /*#__PURE__*/React.createElement(T, {
      source: "tracked_changes_warning"
    })), /*#__PURE__*/React.createElement("div", {
      className: "".concat(plagiarismFiles.length === 0 ? 'shadow rounded p-2' : '', " ").concat(dragActive ? 'hovered' : '')
    }, /*#__PURE__*/React.createElement(Files, {
      apiRoot: endpoints.researcher,
      maxUploads: 1,
      methods: methods,
      name: "plagiarismFiles",
      type: fileType,
      disabled: submitting,
      fileRenderer: FileRubriq,
      required: true,
      fileUploadButton: function fileUploadButton(_ref2) {
        var onClick = _ref2.onClick,
          isDragActive = _ref2.isDragActive,
          disabled = _ref2.disabled;
        filePickerRef.current = onClick;
        return /*#__PURE__*/React.createElement("div", null, !hasFile && /*#__PURE__*/React.createElement("div", {
          className: "d-flex flex-column align-items-center",
          style: {
            border: '2px dashed #e2e8f0',
            borderRadius: '8px',
            height: '300px',
            width: '103%'
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "d-flex flex-column align-items-center pt-3 pb-3",
          style: {
            maxWidth: '400px',
            marginTop: '10px'
          }
        }, /*#__PURE__*/React.createElement("img", {
          src: UploadImage,
          alt: ""
        }), /*#__PURE__*/React.createElement("span", {
          className: "fw-semibold fs-4 mt-3"
        }, /*#__PURE__*/React.createElement(T, {
          source: "drag_and_drop_files"
        })), /*#__PURE__*/React.createElement("span", {
          className: "mt-2 text-center"
        }, /*#__PURE__*/React.createElement(T, {
          source: "click_to_browse"
        })), /*#__PURE__*/React.createElement("button", {
          style: {
            borderRadius: '6px'
          },
          type: "button",
          className: "btn btn-primary mt-4",
          onClick: onCheckDocument,
          disabled: submitting
        }, /*#__PURE__*/React.createElement(T, {
          source: "choose_files"
        }), submitting && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          className: "ms-1",
          icon: "fa-solid fa-spinner-scale",
          spin: true
        }))), /*#__PURE__*/React.createElement(RubriqPlagiarismStatus, {
          isNoEditsMessage: true
        })), /*#__PURE__*/React.createElement("div", {
          style: {
            display: 'none'
          }
        }, /*#__PURE__*/React.createElement(RubriqUploadButton, {
          onClick: onClick,
          isDragActive: isDragActive,
          disabled: disabled,
          onDragStatusChanged: function onDragStatusChanged(active) {
            return setDragActive(active);
          },
          hasFile: hasFile
        })));
      }
    })), showError && /*#__PURE__*/React.createElement("div", {
      className: "text-danger mt-3"
    }, /*#__PURE__*/React.createElement(T, {
      source: "file-upload-error"
    }))),
    isValid: function isValid() {
      return hasFile && plagiarismFiles.every(function (file) {
        return file.status === FILE_STATUS.STATUS_UPLOAD_SUCCESS;
      });
    }
  }];
  var close = function close(result) {
    var errorId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    setSubmitting(false);
    methods.reset(defaultValues);
    setCurrentPageIndex(0);
    setShowError(false);
    wordCountAttempts = 0;
    onClose(result, errorId);
  };
  var handleClickNext = function handleClickNext() {
    if (screens[currentPageIndex].isValid()) {
      setShowError(false);
      if (currentPageIndex < screens.length - 1) {
        setCurrentPageIndex(currentPageIndex + 1);
      }
    } else {
      setShowError(true);
    }
  };
  var handleSubmit = function handleSubmit() {
    methods.handleSubmit(preprocessData(_submitPlagiarism))();
  };
  var _submitPlagiarism = function submitPlagiarism(data) {
    setSubmitting(true);
    var identity = data.plagiarismFiles[0].identity;
    var obj = {
      identity: identity
    };
    dispatch(createPlagiarism(obj, false, false)).then(function (res) {
      var plagiarismError = res.error;
      if (plagiarismError) {
        var errorId = plagiarismError.error;
        if (errorId === 'word-count-not-received') {
          if (wordCountAttempts < 12) {
            setTimeout(function () {
              return _submitPlagiarism(data);
            }, 5000);
            wordCountAttempts += 1;
            return;
          }
        }
        close(false, errorId);
      } else {
        dispatch(syncUser()).then(function () {
          close(true);
        });
      }
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, open && /*#__PURE__*/React.createElement(Modal, {
    appElement: document.querySelector('#researcher-app'),
    isOpen: true,
    overlayClassName: "react-modal-overlay",
    className: "react-modal"
  }, /*#__PURE__*/React.createElement("div", {
    className: "react-modal-header"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-close",
    onClick: function onClick() {
      return close(false);
    },
    "aria-label": t('close')
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/React.createElement("h1", {
    className: "react-modal-title"
  }, screens[currentPageIndex].title)), /*#__PURE__*/React.createElement(Form, {
    methods: methods,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: "react-modal-content",
    style: {
      height: showError ? '480px !important' : '430px !important'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "digital-edits"
  }, screens[currentPageIndex].content)), /*#__PURE__*/React.createElement("div", {
    className: "react-modal-footer"
  }, currentPageIndex === screens.length - 1 ? /*#__PURE__*/React.createElement("button", {
    type: "submit",
    disabled: submitting || !screens[currentPageIndex].isValid(),
    className: "btn btn-primary btn-squared me-3",
    key: "start"
  }, /*#__PURE__*/React.createElement(T, {
    source: "start"
  }), submitting ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-1",
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }) : null) : /*#__PURE__*/React.createElement("button", {
    "aria-label": t('continue'),
    type: "button",
    onClick: handleClickNext,
    className: "btn btn-primary btn-squared me-3",
    key: "continue"
  }, /*#__PURE__*/React.createElement(T, {
    source: "continue"
  })), /*#__PURE__*/React.createElement("button", {
    "aria-label": t('cancel'),
    type: "button",
    onClick: function onClick() {
      return close(false);
    },
    className: "btn btn-secondary btn-squared"
  }, /*#__PURE__*/React.createElement(T, {
    source: "cancel"
  }))))));
};
export default PlagiarismCheckDocumentModal;